// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2LDCu","info":"UpdateTermsInfo_info__3cxMp"};